/**
 * Provides authorization to the application, based on the validation of the ss GET parameter value.  
 * The validation is made issuing an HTTP request to the /validate endpoint with {ss:'<ss_value>'} body.  
 * In development, please use the following url to simulate a valid value:  
 *  http://localhost:3000/?ss=SS_VALID_VALUE
 */
import React from 'react';

import { getConfItem } from '../../conf/conf';
import {
    config as httpClientConfig,
    validate as httpClientValidate
} from '../../libs/http-client';
import { urlGetSolarSpecialist } from '../../helpers/browser-navigation-helper';

import Unauthorized from './Unauthorized';
import Loading from '../Loading';

function withAuthorization(WrappedComponent) {

    return class extends React.Component {

        constructor(props) {
            super(props);
            this.state = {
                loading: false,
                authorized: false,
                redirectTo: false
            };
        }

        async authorize() {
            this.onValidateSolarSpecialistResponse(await this.validateSolarSpecialist());
        }

        async validateSolarSpecialist() {

            this.setState(() => ({
                loading: true
            }));

            httpClientConfig({
                baseUrl: getConfItem('api.' + process.env.NODE_ENV + '.baseUrl')
            });
            
            try {
                const response = await httpClientValidate({
                    ss: urlGetSolarSpecialist()
                });
                return response.data;
            } catch (e) {
                console.error('Authorization Error ', e);
                return {
                    result: 'KO'
                };
            }

        }

        /**
         * Manages the validate HTTP request response
         * @param {Object} response 
         *  .result {String}
         *      ['OK'|'KO']
         */
        onValidateSolarSpecialistResponse(response) {
            if (process.env.NODE_ENV === 'development') {
                if (response.result === 'KO') {
                    console.error('Please use the url: http://localhost:3000/?ss=SS_VALID_VALUE to pass authorization for develpment')
                }
            }
            this.setState({
                loading: false,
                authorized: response.result === 'OK',
                redirectTo: false//response.result === 'KO' ? getConfItem('externalUrls.unauthorized') : false
            });
        }

        componentDidMount() {
            this.authorize();
        }

        render() {

            if (this.state.loading) {
                return <Loading />;
            }

            return (this.state.authorized)
                ? <WrappedComponent { ...this.props }/>
                : <Unauthorized message="Unauthorized" redirectTo={ this.state.redirectTo } />;
        }
    };
}

export default withAuthorization;